export default {
    documents: [
        {
            type : 'Terminliste',
            file : '/documents/Terminliste/7_Terminliste_Kirchgemeinden_2024.pdf',
            number : '',
            description : 'Terminliste für Kirchgemeinden',
            short: '',
        }
    ]
}